import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { dashboardPathForRole } from '../config/routeRoles';

// Redirects to the caller's own dashboard if their role isn't in `roles`.
// Pass no `roles` (or an empty/undefined list) to allow any authenticated role.
const ProtectedRoute = ({ roles, children }) => {
  const { getUserRole } = useAuth();
  const userRole = (getUserRole() || 'ADMIN').toUpperCase();

  if (roles && roles.length > 0 && !roles.includes(userRole)) {
    return <Navigate to={dashboardPathForRole(userRole)} replace />;
  }

  return children;
};

export default ProtectedRoute;
